// material
import {

    Card,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableContainer,
    Container,
} from '@material-ui/core';
// utils
import { RootState, useDispatch, useSelector } from 'redux/store';
import { useEffect } from 'react';
import { getCurrency } from 'redux/slices/currency';
import Page from 'components/Page';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import useLocales from 'hooks/useLocales';
// ----------------------------------------------------------------------

export default function CurrencyList() {
    const { translate } = useLocales();
    const dispatch = useDispatch();
    const { currency } = useSelector(
        (state: RootState) => state.currency
    );


    useEffect(() => {
        dispatch(getCurrency());
    }, [dispatch]);


    return (
        <>  <Page title="Currency">
            <Container maxWidth="xl">

                <HeaderBreadcrumbs
                    heading={translate(`dashboard.${"Currency"}`)}
                    links={[
                        // { name: 'Amount', href: PATH_DASHBOARD.user.root },
                        // { name: 'Delivery Options', href: PATH_DASHBOARD.user.root },
                    ]}
                />
                <Card sx={{ pb: 3 }}>
                    <TableContainer sx={{ minWidth: 720 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Currency code</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Name plural</TableCell>
                                    <TableCell>Symbol</TableCell>
                                    <TableCell>Symbol native</TableCell>
                                </TableRow>
                            </TableHead>
                            {currency !== null &&
                                <TableBody>
                                    {currency.map((row) => (
                                        <TableRow key={row.currencyCode}>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.namePlural}</TableCell>
                                            <TableCell>{row.symbol}</TableCell>
                                            <TableCell>{row.symbolNative}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>}
                        </Table>

                    </TableContainer>
                </Card>
            </Container>
        </Page></>

    );
}